import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import ViewUserPageNew from "../../components/User/ViewUserPageNew";
import ViewTransactionPage from "../../components/Transactions Page/ViewTransactionPage";



const ViewUserPage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb  id="title" title2="Payments And Transactions" link2="/payments-transactions" title="View Payment And Transaction" />
        <ViewTransactionPage/>
      </MasterLayout>
    </>
  );
};

export default ViewUserPage;
